import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Finish Signing Up with Proximal", -1)
const _hoisted_3 = {
  key: 0,
  "aria-label": "legal",
  class: "legal-section"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, "Acknowledge Terms of Use", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "legal-txt" }, "The user hereby acknowledges that the website at https://proximaldtx.com/ is not a certified medical device and that he or she is entitled only to the status ‘as is’. Users use this website on their own responsibility and at their own risk. Neither the authors nor the University of North Carolina assume any guarantees with respect to the use of the website for a certain purpose. Neither the authors nor the University of North Carolina are liable for damages that ensue from the private use of the website in the dental practice. The authors would be happy to receive any feedback on the website. However, neither the authors nor the University of North Carolina are obligated to provide any kind of support of a technical, medical, or other nature", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "NOTE: any use of this application implies that the user has agreed to the terms of use outlined here.", -1)
const _hoisted_7 = { class: "bottom-nav" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  "aria-label": "email-notifications",
  class: "email-signup"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", null, "Email Notifications", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "Would you like to receive periodic updates about Proximal DTX and its offerings?", -1)
const _hoisted_12 = { class: "bottom-nav" }

import api from '@/api/api';
import { apiRequest } from '@/authConfig';
import { useMsal } from '@/msal/useMsal';
import {ref} from 'vue'
import {useRouter} from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const agree = () => {
    showLegal.value = false
}
const emailSignup = async (signup: boolean) => {
    if (signup === true) {    
        const {instance, accounts} = useMsal()
        const idTokenClaims: any = accounts.value[0].idTokenClaims
        const accessToken = instance.acquireTokenSilent(apiRequest)
        await api
        .post('SignUp',
        {
            fullName: idTokenClaims.name,
            email: idTokenClaims.email
        },
        {headers: {Authorization: 'Bearer ' + accessToken}})
    }
    router.push('/Conditions')
}
const showLegal = ref<boolean>(true)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _hoisted_2,
    (showLegal.value)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("button", {
              onClick: _withModifiers(agree, ["prevent"])
            }, "I AGREE", 8, _hoisted_8)
          ])
        ]))
      : (_openBlock(), _createElementBlock("section", _hoisted_9, [
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (emailSignup(true)))
            }, "YES"),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emailSignup(false)))
            }, "NO")
          ])
        ]))
  ]))
}
}

})